<div
  class="initials-avatar"
  [attr.data-initials]="initials"
></div>
